import {PlayerValidator, MapValidator} from '@colonist/game-mechanic-validators'
import {GameClientUserState} from '@colonist/game-base-types'
import {BaseGameModeData, GameModeDataController} from '@colonist/shared-types'
import {ModeSettingEnum, ServerId} from '@colonist/types'
import {NestedReadonly, PlayerState} from '@colonist/game-states'

export class GameClientState {
    serverId: ServerId
    gameModeData: BaseGameModeData
    players: PlayerValidator[]

    /**
    * @deprecated Use `uiGameManager.gameController.mapState` instead
    */
    mapState: MapValidator
    isPlayerTakingOffTurnAction: boolean
    canResign: boolean
    isGameOver: boolean

    constructor() {
        this.players = []
        this.mapState = new MapValidator({
            tileHexStates: {},
            tileCornerStates: {},
            tileEdgeStates: {},
            portEdgeStates: {},
            fogTileGroupStates: {},
        })
        this.isPlayerTakingOffTurnAction = false
        this.canResign = false
        this.isGameOver = false
    }

    initGameModeData(modeSetting: ModeSettingEnum) {
        const gameModeData = GameModeDataController.getModeDataForMode(modeSetting)
        if(gameModeData == undefined) return
        this.gameModeData = gameModeData
    }

    initPlayerControllerStates(newPlayerState: NestedReadonly<PlayerState>, userState: NestedReadonly<GameClientUserState>) {
        const newPlayerController = new PlayerValidator(newPlayerState, userState)
        this.players.push(newPlayerController)
    }

    initMapState(mapState: MapValidator) {
        this.mapState = mapState
    }

    hasOnlyOneHumanPlayer(): boolean {
        let humanPlayers = 0
        for(const player of this.players) {
            if(player.isUser) humanPlayers += 1
        }
        if(humanPlayers == 1) return true
        return false
    }
}
